<template>
  <div class="home">
    <template>
      <b-container class="container-rda">
        <b-row>
          <b-col class="content" v-if="selected">
            <b-row>
              <b-col>
                <Breadcrumb :breadcrumb="breadcrumb" />
              </b-col>
            </b-row>
            <InternalChangesTabs />

            <b-row class="mb-5">
              <b-col>
                <h2 class="purple bold">Atualizar Área do Conhecimento</h2>
              </b-col>
              <b-col class="text-right"> </b-col>
            </b-row>
            <b-row class="mb-5 pb-5">
              <b-col md="1" class="status">
                <b-form-group label="Ativo">
                  <b-form-checkbox
                    v-model="selected.subject.is_active"
                    switch
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="1" class="status" v-if="false">
                <b-form-group label="Editável">
                  <b-form-checkbox
                    v-model="selected.subject.is_editable"
                    switch
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Área do Conhecimento">
                  <multiselect
                    v-model="selected.subject.designation"
                    :options="options"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Selecione"
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                  >
                    <span slot="noResult">Nada encontrado</span>
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <SelectCycles
                  :value="selected.subject.cycle_id"
                  :callback="callbackCycles"
                >
                </SelectCycles>
              </b-col>
              <div class="w-100 mt-5"></div>
              <b-col md="3">
                <b-button class="large blue outline" :to="{ name: 'materias' }"
                  >Voltar</b-button
                >
              </b-col>
              <b-col md="3">
                <b-button @click="update" class="large blue">Salvar</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </div>
</template>

<script>
import DataService from "@/services/subjects.service";

import SelectCycles from "@/components/inputs/SelectCycles.vue";
import InternalChangesTabs from "@/components/InternalChangesTabs.vue";

export default {
  name: "perfil-materia",
  components: {
    SelectCycles,
    InternalChangesTabs,
  },
  data() {
    return {
      isActive: false,
      selected: null,
      is_editable: null,

      subjects: [],
      lists: [],

      options: [
        "Artes",
        "Ciências da Natureza",
        "Ciências Humanas e Sociais",
        "Corpo e Mente",
        "Língua Estrangeira",
        "Língua Portuguesa",
        "Matemática",
      ],

      breadcrumb: [
        {
          text: "Coordenação",
          href: "/coordenacao",
        },
        {
          text: "Alterações internas",
          active: true,
        },
        {
          text: "Áreas do conhecimento",
          href: "/materias",
          active: true,
        },
      ],
    };
  },
  methods: {
    update() {
      DataService.update(this.selected.subject.id, this.selected.subject)
        .then((response) => {
          this.$router.push({ name: "materias" });
          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Área do conhecimento atualizada com sucesso!",
          });

          return response.data;
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel atualizar!",
            footer: "Por favor, verifique se os campos estão preenchidos.",
          });

          return error.response;
        });
    },
    getSelected(id) {
      DataService.get(id)
        .then((response) => {
          this.selected = response.data;
        })
        .catch((error) => {
          return error.response;
        });
    },
    callbackCycles(args) {
      this.selected.subject.cycle_id = args.id;
    },
  },
  mounted() {
    this.getSelected(this.$route.params.id);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.home {
  height: 100%;
}

.container-rda {
  padding-bottom: 0;
}

.tags {
  background-color: $blue;
  border-radius: 5px;
  color: $white;
  font-weight: $bold;
  line-height: 28px;
  margin: 3px 12px 3px 0;
  max-width: 58px;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  width: 100%;
}
</style>
